import styled from 'styled-components';
import { formatToEokMan } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import UnitSwitch from '../../../../func/components/UnitSwitch';
import Tab from './Tab';
import { RealDealData, RealDealDataItem, RealDealFilter } from '../../data';
import { useReportContext } from '../../../../context/DetailContext';
import Pagination from '../../../components/pagination/Pagination';
interface Props {
  realPriceData?: RealDealData;
  sameItemAddr: string;
  realDealFilter: RealDealFilter;
  setRealDealFilter: (RealDealFilter: RealDealFilter) => void;
}

// 동일 물건 실거래가
function SameRealPrice({
  realPriceData,
  sameItemAddr,
  realDealFilter,
  setRealDealFilter,
}: Props) {
  const { itemType, type, exchangeItemCategory } = useReportContext();

  const [acitveTab, setAcitveTab] = useState('매매');
  const [realPriceList, setRealPriceList] = useState<RealDealDataItem[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [unit, setUnit] = useState('평');

  useEffect(() => {
    if (realPriceData) {
      switch (acitveTab) {
        case '매매':
          setRealPriceList(realPriceData.sale);
          break;
        case '전월세':
          setRealPriceList(realPriceData.jeonse);

          break;
        default:
          setRealPriceList(realPriceData.sale);
          break;
      }
    }
  }, [acitveTab, realPriceData]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    setRealDealFilter({ ...realDealFilter, offset: (page - 1) * 6 });
  };

  if (
    realDealFilter.is_same1 === false &&
    realDealFilter.is_same2 === false &&
    acitveTab === '매매' &&
    realPriceList.length === 0
  )
    return null;

  return (
    <Container id="list-top-same">
      <TitleWithCheckbox>
        <TitleWrapper>
          <TitleBox>
            <TitleContent>
              <img src="/assets/images/icon/icon_sameAddress.svg" alt="" />
              <div>동일 물건 실거래가</div>
            </TitleContent>
            <UnitSwitch unit={unit} setUnit={setUnit} />
          </TitleBox>
          <div>{sameItemAddr ? <BlueTag>{sameItemAddr}</BlueTag> : null}</div>
        </TitleWrapper>
        <CheckboxWrapper>
          <Checkbox
            $isOn={realDealFilter.is_same1}
            onClick={() => {
              setRealDealFilter({
                ...realDealFilter,
                is_same1: !realDealFilter.is_same1,
                offset: 0,
              });
              setCurrentPage(1);
            }}
          >
            <img
              src={`/assets/images/check/${realDealFilter.is_same1 ? 'circle-checked-blue' : 'circle-checked-gray-outline'}.svg`}
              alt=""
            />
            동일면적 찾기
          </Checkbox>
          <Checkbox
            $isOn={realDealFilter.is_same2}
            onClick={() => {
              setRealDealFilter({
                ...realDealFilter,
                is_same2: !realDealFilter.is_same2,
                offset: 0,
              });
              setCurrentPage(1);
            }}
          >
            <img
              src={`/assets/images/check/${realDealFilter.is_same2 ? 'circle-checked-blue' : 'circle-checked-gray-outline'}.svg`}
              alt=""
            />
            동일층수 찾기
          </Checkbox>
        </CheckboxWrapper>
      </TitleWithCheckbox>
      <Tab
        tab={acitveTab}
        setTab={setAcitveTab}
        setCurrentPage={setCurrentPage}
        isOnlySale={
          !(type === 'e'
            ? exchangeItemCategory
            : (realPriceData?.ptype ?? '')) ||
          ['단독', '빌딩', '공장', '창고', '토지'].includes(
            type === 'e' ? exchangeItemCategory : (realPriceData?.ptype ?? ''),
          ) ||
          itemType === 'L'
        }
      />
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderTop: '1px solid #E5E8EA',
        }}
      >
        {!(type === 'e'
          ? exchangeItemCategory
          : (realPriceData?.ptype ?? '')) ||
        ['단독', '빌딩', '공장', '창고', '토지'].includes(
          type === 'e' ? exchangeItemCategory : (realPriceData?.ptype ?? ''),
        ) ||
        itemType === 'L' ? (
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead style={{ width: '100%' }}>
              <tr>
                <TableHeadTh width="16%" rowSpan={1}>
                  거래일
                </TableHeadTh>
                <TableHeadTh width="42%" colSpan={1}>
                  금액(단가 평/m²)
                </TableHeadTh>
                <TableHeadTh width="42%" rowSpan={1}>
                  면적({unit === '평' ? '평' : 'm²'}) <br />
                </TableHeadTh>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              {realPriceList.length > 0 &&
                acitveTab === '매매' &&
                realPriceList.map((data, index) => (
                  <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                    <TablebodyTd width="16%">
                      {data.dealdate.split('T')[0]}
                    </TablebodyTd>
                    <TablebodyTd width="42%" style={{ textAlign: 'end' }}>
                      {formatToEokMan(data.dealprice)}
                      <br></br>(
                      {unit === '평'
                        ? formatToEokMan(data.price_per_pyeong)
                        : formatToEokMan(data.price_per_pyeong / 3.3058)}
                      / {unit === '평' ? '평' : 'm²'})
                    </TablebodyTd>
                    <TablebodyTd width="42%">
                      {unit === '평'
                        ? data.pyeong
                        : (data.pyeong * 3.3058).toFixed(1)}
                      {unit === '평' ? '평' : 'm²'}
                    </TablebodyTd>
                  </tr>
                ))}
              {realPriceList.length === 0 && NoDataMessage()}
            </tbody>
          </table>
        ) : (
          <table
            style={{
              borderCollapse: 'collapse',
              width: '100%',
            }}
          >
            <thead style={{ width: '100%' }}>
              <tr>
                <TableHeadTh width="16%" rowSpan={1}>
                  거래일
                </TableHeadTh>
                <TableHeadTh width="42%" colSpan={1}>
                  금액(단가 평/m²)
                </TableHeadTh>
                <TableHeadTh width="42%" rowSpan={1}>
                  면적({unit === '평' ? '평' : 'm²'}) <br />
                  (층)
                </TableHeadTh>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              {realPriceList.length > 0 &&
                acitveTab === '매매' &&
                realPriceList.map((data, index) => (
                  <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                    <TablebodyTd width="16%">
                      {data.dealdate.split('T')[0]}
                    </TablebodyTd>
                    <TablebodyTd width="42%" style={{ textAlign: 'end' }}>
                      {formatToEokMan(data.dealprice)}
                      <br></br>(
                      {unit === '평'
                        ? formatToEokMan(data.price_per_pyeong)
                        : formatToEokMan(data.price_per_pyeong / 3.3058)}
                      / {unit === '평' ? '평' : 'm²'})
                    </TablebodyTd>
                    <TablebodyTd width="42%">
                      {unit === '평'
                        ? data.pyeong
                        : (data.pyeong * 3.3058).toFixed(1)}
                      {unit === '평' ? '평' : 'm²'}
                      <br />(
                      {data.floor > 0 ? data.floor : `B${Math.abs(data.floor)}`}
                      층)
                    </TablebodyTd>
                  </tr>
                ))}
              {realPriceList.length > 0 &&
                acitveTab === '전˙월세' &&
                realPriceList.map((data, index) => (
                  <tr style={{ borderBottom: '1px solid #e8e9ea' }} key={index}>
                    <TablebodyTd width="16%">
                      {data.dealdate.split('T')[0]}
                    </TablebodyTd>
                    <TablebodyTd width="42%">
                      <PriceTagBox>
                        {data.dealprice2 !== 0 ? (
                          <PriceTagRow>
                            <span>{formatToEokMan(data.dealprice)}</span>/
                            <span>{formatToEokMan(data.dealprice2)}</span>
                          </PriceTagRow>
                        ) : (
                          <PriceTagRow>
                            <span>{formatToEokMan(data.dealprice)}</span>
                          </PriceTagRow>
                        )}
                        {/* <br></br> */}
                        <div>
                          {unit === '평'
                            ? formatToEokMan(data.price_per_pyeong)
                            : formatToEokMan(data.price_per_pyeong / 3.3058)}
                          / {unit === '평' ? '평' : 'm²'}
                        </div>
                      </PriceTagBox>
                    </TablebodyTd>
                    <TablebodyTd width="42%">
                      {unit === '평'
                        ? data.pyeong
                        : (data.pyeong * 3.3058).toFixed(1)}
                      {unit === '평' ? '평' : 'm²'}
                      <br></br>(
                      {data.floor > 0 ? data.floor : `B${Math.abs(data.floor)}`}
                      층)
                    </TablebodyTd>
                  </tr>
                ))}
              {realPriceList.length === 0 && NoDataMessage()}
            </tbody>
          </table>
        )}
      </div>
      {realPriceList.length > 0 && (
        <Pagination
          removeMargin={true}
          currentPage={currentPage}
          totalPages={Math.ceil(
            Number(
              acitveTab === '매매'
                ? (realPriceData?.sale_total ?? 0)
                : Number(realPriceData?.jeonse_total ?? 0) +
                    Number(realPriceData?.monthly_total ?? 0),
            ) / 6,
          )}
          onPageChange={handlePageChange}
          scrollTargetId="list-top-same"
        />
      )}
    </Container>
  );
}

export default SameRealPrice;

function NoDataMessage() {
  return (
    <tr style={{ borderBottom: '1px solid #e8e9ea' }}>
      <TablebodyTd width="100%" colSpan={4}>
        최근 10년 실거래 이력이 없습니다.
      </TablebodyTd>
    </tr>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  background: white;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
`;

const TitleWithCheckbox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const Checkbox = styled.div<{ $isOn?: boolean }>`
  flex-direction: row;
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 5px 2px 4px;
  display: flex;
  gap: 2px;
  align-items: center;

  font-weight: 500;
  font-size: 12px;
  color: ${({ $isOn }) => ($isOn ? '#008AFF' : '#37383c9c')};

  & > img {
    width: 16px;
    height: 16px;
  }
`;
interface WidthProps {
  width: string;
}

const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  &:last-child {
    border-right: none;
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;

  &:last-child {
    border-right: none;
  }
`;

const BlueTag = styled.span`
  padding: 3px 8px;
  border-radius: 4px;
  background: #f2f7ff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.95px;
  letter-spacing: -0.28px;
  color: #008aff;
`;

const PriceTagBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  // gap: 6px;
`;
const PriceTagRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  // padding: 0 6px;
`;
